// Google Analytics utility functions
// Tracking ID: G-Z4WD7SBPS6
export const GA_TRACKING_ID = 'G-Z4WD7SBPS6';
// Check if gtag is available
export const isGtagAvailable = () => {
    return typeof window !== 'undefined' && typeof window.gtag === 'function';
};
// Track page views
export const trackPageView = (url, title) => {
    var _a;
    if (isGtagAvailable()) {
        (_a = window.gtag) === null || _a === void 0 ? void 0 : _a.call(window, 'config', GA_TRACKING_ID, {
            page_path: url,
            page_title: title || document.title,
        });
        console.log('GA Page View:', url);
    }
};
// Track custom events
export const trackEvent = (action, category, label, value) => {
    var _a;
    if (isGtagAvailable()) {
        (_a = window.gtag) === null || _a === void 0 ? void 0 : _a.call(window, 'event', action, {
            event_category: category,
            event_label: label,
            value: value,
        });
        console.log('GA Event:', { action, category, label, value });
    }
};
// Track exceptions/errors
export const trackException = (description, fatal = false) => {
    var _a;
    if (isGtagAvailable()) {
        (_a = window.gtag) === null || _a === void 0 ? void 0 : _a.call(window, 'event', 'exception', {
            description: description,
            fatal: fatal,
        });
    }
};
// Track user login
export const trackLogin = (method) => {
    trackEvent('login', 'engagement', method);
};
// Track user logout
export const trackLogout = () => {
    trackEvent('logout', 'engagement');
};
// Track search queries
export const trackSearch = (searchTerm) => {
    trackEvent('search', 'engagement', searchTerm);
};
// Track file downloads
export const trackDownload = (fileName) => {
    trackEvent('file_download', 'engagement', fileName);
};
